export default class Address {
  private zipcode: string = '';

  private street: string = '';

  private complement: string = '';

  private district: string = '';

  private city: string = '';

  private state: string = '';

  private ibge: string = '';

  private gia: string = '';

  private ddd: string = '';

  private siafi: string = '';

  private number: string = '';

  constructor(data: any = {}) {
    this.zipcode = data.cep || '';
    this.street = data.logradouro || '';
    this.complement = data.complemento || '';
    this.district = data.bairro || '';
    this.city = data.localidade || '';
    this.state = data.uf || '';
    this.ibge = data.ibge || '';
    this.gia = data.gia || '';
    this.ddd = data.ddd || '';
    this.siafi = data.siafi || '';
    this.number = data.numero || '';
  }

  public formatPayload() {
    return {
      zipcode: this.zipcode.replace('-', ''),
      street: this.street,
      complement: this.complement,
      district: this.district,
      city: this.city,
      state: this.state,
      number: this.number,
    }
  }
}
